<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="accountInfo"></ng-container>
            <ng-container *ngTemplateOutlet="kidInfo"></ng-container>
            <ng-container *ngTemplateOutlet="projectInfo"></ng-container>
            <tt-button-save ttText="businesscoaccounting_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>

        <ng-container *ngTemplateOutlet="gridLists"></ng-container>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="businesscoaccounting_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="35">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="accountInfo"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="35">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="kidInfo"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <ng-container *ngTemplateOutlet="projectInfo"></ng-container>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>

        <tt-card class="col-xs-12 p-5">
            <tt-button-save ttText="businesscoaccounting_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>

        <div class="col-xs-12 p-5">
            <ng-container *ngTemplateOutlet="gridLists"></ng-container>
        </div>
    </div>
</tt-page>

<ng-template #accountInfo>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="businessco_no" [ttModel]="page.businessco_no" ttReadonly></tt-input>
        <tt-input ttLabel="businessco_companyname" [ttModel]="page.businessco_companyname" ttReadonly></tt-input>
        <tt-input ttLabel="bank_account" [(ttModel)]="page.bank_account"></tt-input>
        <tt-input ttLabel="bankintegration_api_company_id" [(ttModel)]="page.bankintegration_api_company_id"></tt-input>
        <tt-search ttLabel="freight_account_name" [(ttModel)]="page.freight_account_name" [ttSearch]="searchFreightAccountNames" (ttOnSelected)="onFreightAccountNameSelected($event)" (ttOnClear)="onFreightAccountNameSelected()"></tt-search>
        <tt-search ttLabel="account_name_agio" [(ttModel)]="page.account_name_agio" [ttSearch]="searchAccountNameAgios" (ttOnSelected)="onAccountNameAgioSelected($event)" (ttOnClear)="onAccountNameAgioSelected()"></tt-search>
        <tt-search ttLabel="account_name_disagio" [(ttModel)]="page.account_name_disagio" [ttSearch]="searchAccountNameDisAgios" (ttOnSelected)="onAccountNameDisAgioSelected($event)" (ttOnClear)="onAccountNameDisAgioSelected()"></tt-search>
        <tt-search ttLabel="account_name_bank_fees" [(ttModel)]="page.account_name_bank_fees" [ttSearch]="searchAccountNameBankFees" (ttOnSelected)="onAccountNameBankFeeSelected($event)" (ttOnClear)="onAccountNameBankFeeSelected()"></tt-search>
        <tt-search ttLabel="account_name_ocr" [(ttModel)]="page.account_name_ocr" [ttSearch]="searchAccountNameOcrs" (ttOnSelected)="onAccountNameOcrSelected($event)" (ttOnClear)="onAccountNameOcrSelected()"></tt-search>
        <tt-search ttLabel="account_name_roundoff" [(ttModel)]="page.account_name_roundoff" [ttSearch]="searchAccountNameRoundOffs" (ttOnSelected)="onAccountNameRoundOffSelected($event)" (ttOnClear)="onAccountNameRoundOffSelected()"></tt-search>
        <tt-select [hidden]="page.bankintegration_external_api_keyno !== '0'" ttLabel="bankintegration_external_api" [(ttModel)]="page.bankintegration_external_api_keyno" [ttData]="selectListExternalApis" ttDataId="item_id" ttDataName="item_name" [ttButtons]="externalApisListButtons"></tt-select>
        <tt-select [hidden]="page.bankintegration_external_api_keyno === '0'" ttLabel="bankintegration_external_api" [(ttModel)]="page.bankintegration_external_api_keyno" [ttData]="selectListExternalApis" ttDataId="item_id" ttDataName="item_name" [ttButtons]="externalApisEditButtons"></tt-select>
    </ng-container>
</ng-template>

<ng-template #kidInfo>
    <ng-container *ngIf="!!page">
        <tt-checkbox ttLabel="use_tt_accouning_system" [(ttModel)]="page.use_tt_accouning_system"></tt-checkbox>
        <tt-checkbox ttLabel="account_cogs_sale" [(ttModel)]="page.account_cogs_sale"></tt-checkbox>
        <tt-input-number ttLabel="invoiceline_cost_from_invoice_no" [(ttModel)]="page.invoiceline_cost_from_invoice_no" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-date ttLabel="transdate_restrict" [(ttModel)]="page.transdate_restrict"></tt-date>
        <tt-date ttLabel="transdate_restrict_max" [(ttModel)]="page.transdate_restrict_max"></tt-date>
        <tt-checkbox ttLabel="use_invoice_no2" [(ttModel)]="page.use_invoice_no2"></tt-checkbox>
        <tt-date ttLabel="kid_cust_no_start" [(ttModel)]="page.kid_cust_no_start"></tt-date>
        <tt-date ttLabel="kid_cust_no_length" [(ttModel)]="page.kid_cust_no_length"></tt-date>
        <tt-date ttLabel="kid_invoice_no_start" [(ttModel)]="page.kid_invoice_no_start"></tt-date>
        <tt-date ttLabel="kid_invoice_no_length" [(ttModel)]="page.kid_invoice_no_length"></tt-date>
        <tt-date ttLabel="tt_accounting_start_date" [(ttModel)]="page.tt_accounting_start_date"></tt-date>
        <tt-checkbox ttLabel="syncronize_acc_cust_no_with_cust_no" [(ttModel)]="page.syncronize_acc_cust_no_with_cust_no"></tt-checkbox>
    </ng-container>
</ng-template>

<ng-template #projectInfo>
    <ng-container *ngIf="!!page">
        <tt-select ttLabel="personal_timeaccount_salarytype" [(ttModel)]="page.personal_timeaccount_salarytype_id" [ttData]="selectListSalaryTypes" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-checkbox ttLabel="account_no_from_product" [(ttModel)]="page.account_no_from_product"></tt-checkbox>
        <tt-search ttLabel="project_accrual_revenue_account_no" [(ttModel)]="page.project_accrual_revenue_account_name" [ttSearch]="searchRevenueAccountNames" (ttOnSelected)="onRevenueAccountNameSelected($event)" (ttOnClear)="onRevenueAccountNameSelected()"></tt-search>
        <tt-search ttLabel="project_accrual_revenue_balance_account_no" [(ttModel)]="page.project_accrual_revenue_balance_account_name" [ttSearch]="searchRevenueBalanceAccountNames" (ttOnSelected)="onRevenueBalanceAccountNameSelected($event)" (ttOnClear)="onRevenueBalanceAccountNameSelected()"></tt-search>
        <tt-search ttLabel="project_accrual_cost_account_no" [(ttModel)]="page.project_accrual_cost_account_name" [ttSearch]="searchCostAccountNames" (ttOnSelected)="onCostAccountNameSelected($event)" (ttOnClear)="onCostAccountNameSelected()"></tt-search>
        <tt-search ttLabel="project_accrual_cost_balance_account_no" [(ttModel)]="page.project_accrual_cost_balance_account_name" [ttSearch]="searchCostBalanceAccountNames" (ttOnSelected)="onCostBalanceAccountNameSelected($event)" (ttOnClear)="onCostBalanceAccountNameSelected()"></tt-search>
    </ng-container>
</ng-template>

<ng-template #gridLists>
    <ng-container *ngIf="!!page">
        <tt-grid *ngIf="!!gridReminder" [(ttOptions)]="gridReminder"></tt-grid>
        <tt-grid *ngIf="!!gridBankAccount" [(ttOptions)]="gridBankAccount"></tt-grid>
    </ng-container>
</ng-template>

<!--<div class="col-xs-12 sp-0">
    <div class="row-fluid">
        <form class="form-horizontal im-no-pad" name="formBusinessCoAccounting" novalidate method="get" role="form">
            <div class="col-xs-12 col-md-4 sp-5" style="margin-top: 5px; margin-bottom: 5px">
                <div class="well well-sm col-xs-12">
                    <tt-input class="col-xs-12 sp-0" tt-label="businessco_no" tt-model="vm.model.edit.businessco_no" tt-change="vm.model.edit.businessco_no = $value" tt-readonly="true"></tt-input>
                    <tt-input class="col-xs-12 sp-0"
                              tt-label="businessco_companyname"
                              tt-model="vm.model.edit.businessco_companyname"
                              tt-change="vm.model.edit.businessco_companyname = $value"
                              tt-readonly="true"></tt-input>
                    <tt-input class="col-xs-12 sp-0" tt-label="bank_account" tt-model="vm.model.edit.bank_account" tt-change="vm.model.edit.bank_account = $value" tt-readonly="false"></tt-input>
                    <tt-input class="col-xs-12 sp-0"
                              tt-label="bankintegration_api_company_id"
                              tt-model="vm.model.edit.bankintegration_api_company_id"
                              tt-change="vm.model.edit.bankintegration_api_company_id = $value"
                              tt-readonly="false"></tt-input>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="freight_account_name"
                               tt-model="vm.model.edit.freight_account_name"
                               tt-change="vm.onChanged($value, $item)"
                               tt-on-selected="vm.onSelected($item)"
                               tt-on-clear="vm.onClear()"
                               tt-search="vm.typeaheadSearch(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="account_name_agio"
                               tt-model="vm.model.edit.account_name_agio"
                               tt-change="vm.onChangedAgio($value, $item)"
                               tt-on-selected="vm.onSelectedAgio($item)"
                               tt-on-clear="vm.onClearAgio()"
                               tt-search="vm.typeaheadSearchAgio(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="account_name_disagio"
                               tt-model="vm.model.edit.account_name_disagio"
                               tt-change="vm.onChangedDisAgio($value, $item)"
                               tt-on-selected="vm.onSelectedDisAgio($item)"
                               tt-on-clear="vm.onClearDisAgio()"
                               tt-search="vm.typeaheadSearchDisAgio(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="account_name_bank_fees"
                               tt-model="vm.model.edit.account_name_bank_fees"
                               tt-change="vm.onChangedBankFees($value, $item)"
                               tt-on-selected="vm.onSelectedBankFees($item)"
                               tt-on-clear="vm.onClearBankFees()"
                               tt-search="vm.typeaheadSearchBankFees(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="account_name_ocr"
                               tt-model="vm.model.edit.account_name_ocr"
                               tt-change="vm.onChangedOcr($value, $item)"
                               tt-on-selected="vm.onSelectedOcr($item)"
                               tt-on-clear="vm.onClearOcr()"
                               tt-search="vm.typeaheadSearchOcr(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="account_name_roundoff"
                               tt-model="vm.model.edit.account_name_roundoff"
                               tt-change="vm.onChangedAccountNameRoundOff($value, $item)"
                               tt-on-selected="vm.onSelectedAccountNameRoundOff($item)"
                               tt-on-clear="vm.onClearAccountNameRoundOff()"
                               tt-search="vm.typeaheadSearchAccountNameRoundOff(value)"></tt-search>
                    <div ng-show="vm.model.edit.bankintegration_external_api_keyno === '0'">
                        <tt-select-buttons class="col-xs-12 sp-0"
                                           tt-label="bankintegration_external_api"
                                           tt-model="vm.model.edit.bankintegration_external_api_keyno"
                                           tt-change="vm.model.edit.bankintegration_external_api_keyno = $value"
                                           tt-data="vm.model.selectListExternalApis"
                                           tt-data-id="item_id"
                                           tt-data-name="item_name"
                                           tt-buttons="vm.model.externalApisButtons1"></tt-select-buttons>
                    </div>
                    <div ng-show="vm.model.edit.bankintegration_external_api_keyno > 0">
                        <tt-select-buttons class="col-xs-12 sp-0"
                                           tt-label="bankintegration_external_api"
                                           tt-model="vm.model.edit.bankintegration_external_api_keyno"
                                           tt-change="vm.model.edit.bankintegration_external_api_keyno = $value"
                                           tt-data="vm.model.selectListExternalApis"
                                           tt-data-id="item_id"
                                           tt-data-name="item_name"
                                           tt-buttons="vm.model.externalApisButtons2"></tt-select-buttons>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-4 sp-5" style="margin-top: 5px; margin-bottom: 5px">
                <div class="well well-sm col-xs-12">
                    <tt-checkbox class="col-xs-12 sp-0"
                                 tt-label="use_tt_accouning_system"
                                 tt-model="vm.model.edit.use_tt_accouning_system"
                                 tt-change="vm.model.edit.use_tt_accouning_system = $value"></tt-checkbox>
                    <tt-checkbox class="col-xs-12 sp-0" tt-label="account_cogs_sale" tt-model="vm.model.edit.account_cogs_sale" tt-change="vm.model.edit.account_cogs_sale = $value"></tt-checkbox>
                    <tt-input-number class="col-xs-12 sp-0" tt-label="invoiceline_cost_from_invoice_no" tt-model="vm.model.edit.invoiceline_cost_from_invoice_no" tt-change="vm.model.edit.invoiceline_cost_from_invoice_no = $value" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 0 }" tt-readonly="false"></tt-input-number>
                    <tt-datetime class="col-xs-12 sp-0"
                                 tt-label="transdate_restrict"
                                 tt-model="vm.model.edit.transdate_restrict"
                                 tt-change="vm.model.edit.transdate_restrict = $value"
                                 tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: false, disabled: false, align: 'right'}, minute: {show: false, disabled: false, align: 'right', interval: 1}}"></tt-datetime>
                    <tt-datetime class="col-xs-12 sp-0"
                                 tt-label="transdate_restrict_max"
                                 tt-model="vm.model.edit.transdate_restrict_max"
                                 tt-change="vm.model.edit.transdate_restrict_max = $value"
                                 tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: false, disabled: false, align: 'right'}, minute: {show: false, disabled: false, align: 'right', interval: 1}}"></tt-datetime>
                    <tt-checkbox class="col-xs-12 sp-0" tt-label="use_invoice_no2" tt-model="vm.model.edit.use_invoice_no2" tt-change="vm.model.edit.use_invoice_no2 = $value"></tt-checkbox>
                    <tt-input-number class="col-xs-12 sp-0"
                                     tt-label="kid_cust_no_start"
                                     tt-model="vm.model.edit.kid_cust_no_start"
                                     tt-change="vm.model.edit.kid_cust_no_start = $value"
                                     tt-placeholder=""
                                     tt-style=""
                                     tt-text-align="right"
                                     tt-options="{ decimals: 0 }"
                                     tt-readonly="false"></tt-input-number>
                    <tt-input-number class="col-xs-12 sp-0"
                                     tt-label="kid_cust_no_length"
                                     tt-model="vm.model.edit.kid_cust_no_length"
                                     tt-change="vm.model.edit.kid_cust_no_length = $value"
                                     tt-placeholder=""
                                     tt-style=""
                                     tt-text-align="right"
                                     tt-options="{ decimals: 0 }"
                                     tt-readonly="false"></tt-input-number>
                    <tt-input-number class="col-xs-12 sp-0"
                                     tt-label="kid_invoice_no_start"
                                     tt-model="vm.model.edit.kid_invoice_no_start"
                                     tt-change="vm.model.edit.kid_invoice_no_start = $value"
                                     tt-placeholder=""
                                     tt-style=""
                                     tt-text-align="right"
                                     tt-options="{ decimals: 0 }"
                                     tt-readonly="false"></tt-input-number>
                    <tt-input-number class="col-xs-12 sp-0"
                                     tt-label="kid_invoice_no_length"
                                     tt-model="vm.model.edit.kid_invoice_no_length"
                                     tt-change="vm.model.edit.kid_invoice_no_length = $value"
                                     tt-placeholder=""
                                     tt-style=""
                                     tt-text-align="right"
                                     tt-options="{ decimals: 0 }"
                                     tt-readonly="false"></tt-input-number>
                    <tt-datetime class="col-xs-12 sp-0"
                                 tt-label="tt_accounting_start_date"
                                 tt-model="vm.model.edit.tt_accounting_start_date"
                                 tt-change="vm.model.edit.tt_accounting_start_date = $value"
                                 tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: false, disabled: false, align: 'right'}, minute: {show: false, disabled: false, align: 'right', interval: 1}}"></tt-datetime>
                    <tt-checkbox class="col-xs-12 sp-0"
                                 tt-label="syncronize_acc_cust_no_with_cust_no"
                                 tt-model="vm.model.edit.syncronize_acc_cust_no_with_cust_no"
                                 tt-change="vm.model.edit.syncronize_acc_cust_no_with_cust_no = $value"></tt-checkbox>
                </div>
            </div>

            <div class="col-xs-12 col-md-4 sp-5" style="margin-top: 5px; margin-bottom: 5px">
                <div class="well well-sm col-xs-12">
                    <tt-select class="col-xs-12 sp-0"
                               tt-label="personal_timeaccount_salarytype"
                               tt-model="vm.model.edit.personal_timeaccount_salarytype_id"
                               tt-change="vm.model.edit.personal_timeaccount_salarytype_id = $value"
                               tt-data="vm.model.selectListSalaryTypes"
                               tt-data-id="item_id"
                               tt-data-name="item_name"></tt-select>
                    <tt-checkbox class="col-xs-12 sp-0"
                                 tt-label="account_no_from_product"
                                 tt-model="vm.model.edit.account_no_from_product"
                                 tt-change="vm.model.edit.account_no_from_product = $value"></tt-checkbox>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="project_accrual_revenue_account_no"
                               tt-model="vm.model.edit.project_accrual_revenue_account_name"
                               tt-change="vm.onChangedDisAgio($value, $item)"
                               tt-on-selected="vm.onSelectedProjectAccrualRevenueAccount($item)"
                               tt-on-clear="vm.onSelectedProjectAccrualRevenueAccount()"
                               tt-search="vm.typeaheadSearchAccount(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="project_accrual_revenue_balance_account_no"
                               tt-model="vm.model.edit.project_accrual_revenue_balance_account_name"
                               tt-change="vm.onChangedDisAgio($value, $item)"
                               tt-on-selected="vm.onSelectedProjectAccrualBalanceAccount($item)"
                               tt-on-clear="vm.onSelectedProjectAccrualBalanceAccount()"
                               tt-search="vm.typeaheadSearchAccount(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="project_accrual_cost_account_no"
                               tt-model="vm.model.edit.project_accrual_cost_account_name"
                               tt-change="vm.onChangedProjectAccrualCostAccount($value, $item)"
                               tt-on-selected="vm.onSelectedProjectAccrualCostAccount($item)"
                               tt-on-clear="vm.onSelectedProjectAccrualCostAccount()"
                               tt-search="vm.typeaheadSearchAccount(value)"></tt-search>
                    <tt-search class="col-xs-12 sp-0"
                               tt-label="project_accrual_cost_balance_account_no"
                               tt-model="vm.model.edit.project_accrual_cost_balance_account_name"
                               tt-change="vm.onChangedProjectAccrualCostBalanceAccount($value, $item)"
                               tt-on-selected="vm.onSelectedProjectAccrualcostBalanceeAccount($item)"
                               tt-on-clear="vm.onSelectedProjectAccrualcostBalanceeAccount()"
                               tt-search="vm.typeaheadSearchAccount(value)"></tt-search>
                </div>
            </div>

            <div class="col-xs-12 col-md-12 sp-5" style="margin-top: 5px; margin-bottom: 5px">
                <div class="well well-sm col-xs-12">
                    <tt-button-save class="col-xs-12 sp-0" tt-text="businesscoaccounting_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
                </div>
            </div>

            <div class="col-xs-12 col-md-12 sp-5" style="margin-top: 5px; margin-bottom: 5px">
                <tt-grid tt-options="vm.grid" ng-if="vm.model.gridReady"></tt-grid>
            </div>
            <div class="col-xs-12 sp-0">
                <tt-grid tt-options="vm.gridBankAccount" ng-if="vm.model.gridBankAccountReady"></tt-grid>
            </div>
        </form>
    </div>
</div>-->
